const ROLLOUTS = {
    QUAL_REVIEWS_WORK_SAMPLE_WEB_MOBILE: 'qualas_reviews_work_sample_web_mobile',
    GIG_PAGE_SBSS_INDICATION: 'qualas_gig_page_sbss_indication',
    FOXES_CREATE_BRIEF: 'foxes_create_new_brief_page',
    GIG_WORKFLOW_IN_GIG_EDIT: 'gig_workflow_in_gig_edit',
    GIG_WORKFLOW_IN_GIG_PAGE: 'gig_workflow_in_gig_page',
    FOXES_CONTACT_SELLER_OPTIONS: 'foxes_contact_seller_options',
    QUALAS_REVIEWS_SBSS_INDICATION: 'qualas_reviews_sbss_indication',
    LIONS_FINAL_PRICE_UPFRONT: 'lions_final_price_upfront',
    LIONS_CONTACT_SELLER_MT_PROMOTION: 'lions_contact_seller_mt_promotion',
    GIG_PAGE_BASE_DATA_ENDPOINT: 'gig_page_base_data_endpoint',
    GIG_PAGE_VOICE_OVER_AI_AUDITION: 'gig_page_voice_over_ai_audition',
    GOATS_SKIP_EXTRAS_PAGE_WEB: 'goats_skip_extras_page_web',
    GOATS_SKIP_EXTRAS_PAGE_MOBILE_WEB: 'goats_skip_extras_page_mobile_web',
    MUSTANGS_BUSINESS_GIG_PAGE: 'mustangs_business_gig_page',
    PANTHERS_FMP_IMPROVEMENTS: 'panthers_fmp_improvements',
    ZEBRAS_DISCOVER_FIB_MODAL: 'zebras_discover_fib_modal',
    GOATS_GUEST_SKIP_CHECKOUT_WEB: 'goats_guest_skip_checkout_web',
    GOATS_GUEST_SKIP_CHECKOUT_MOBILE_WEB: 'goats_guest_skip_checkout_mobile_web',
    QUALAS_HIGHLY_RESPONSIVE_INDICATION: 'qualas_highly_responsive_indication_on_gig_page',
    CHAM_CLOSE_GIG_PAGE_KNOWN_CRAWLER_TRAFFIC: 'cham_close_gig_page_known_crawler_traffic',
    QUAL_REVIEWS_PRICE_RANGES: 'qual_reviews_price_ranges',
    ZEBRAS_ACQ_COLLECTION_STEPPER: 'zebras_acq_collection_stepper_gig_page'
};

const ROLLOUT_STATUS = {
    CLOSED: 0,
    ACTIVE: 1
};

module.exports = {
    ROLLOUTS,
    ROLLOUT_STATUS
};
